import { MenuItemType } from './menu-item.model';

export interface HeaderMenuDefaultItem {
	type: MenuItemType;
	defaultLabelKey: string;
}

export const DEFAULT_HEADER_MENU_ITEMS: readonly HeaderMenuDefaultItem[] = [
	{ type: MenuItemType.Home, defaultLabelKey: 'menu.navigation.home' },
	{ type: MenuItemType.Destination, defaultLabelKey: 'menu.navigation.destinations' },
	{ type: MenuItemType.LastMinute, defaultLabelKey: 'menu.navigation.lastMinute' },
	{ type: MenuItemType.FirstMinute, defaultLabelKey: 'menu.navigation.firstMinute' },
	{ type: MenuItemType.Premium, defaultLabelKey: 'menu.navigation.premium' },
	{ type: MenuItemType.SpecialOffer, defaultLabelKey: 'menu.navigation.specialOffer' },
	{ type: MenuItemType.Contact, defaultLabelKey: 'menu.navigation.contact' },
	{ type: MenuItemType.AboutUs, defaultLabelKey: 'menu.navigation.aboutUs' },
];
